import { render, staticRenderFns } from "./AudioPlayerBtn.vue?vue&type=template&id=3439a2ce&scoped=true&lang=pug"
import script from "./AudioPlayerBtn.vue?vue&type=script&lang=ts"
export * from "./AudioPlayerBtn.vue?vue&type=script&lang=ts"
import style0 from "./AudioPlayerBtn.vue?vue&type=style&index=0&id=3439a2ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439a2ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
